import { Text } from 'wikr-core-components';
import styled from 'styled-components';

export const ErrorSubtitle = styled(Text)`
    white-space: pre-wrap;
`;
